/**
 * Do not edit directly
 * Generated on Mon, 12 Sep 2022 09:55:51 GMT
 */

module.exports = {
  "color": {
    "branding": {
      "value": "#0030c0",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgb(0, 48, 192)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBranding",
      "path": [
        "color",
        "branding"
      ]
    },
    "branding-80": {
      "value": "rgba(0, 48, 192, 0.8)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(0, 48, 192, 0.8)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBranding80",
      "path": [
        "color",
        "branding-80"
      ]
    },
    "branding-60": {
      "value": "rgba(0, 48, 192, 0.6)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(0, 48, 192, 0.6)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBranding60",
      "path": [
        "color",
        "branding-60"
      ]
    },
    "branding-40": {
      "value": "rgba(0, 48, 192, 0.4)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(0, 48, 192, 0.4)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBranding40",
      "path": [
        "color",
        "branding-40"
      ]
    },
    "branding-20": {
      "value": "rgba(0, 48, 192, 0.2)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(0, 48, 192, 0.2)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBranding20",
      "path": [
        "color",
        "branding-20"
      ]
    },
    "branding-16": {
      "value": "rgba(0, 48, 192, 0.16)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(0, 48, 192, 0.16)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBranding16",
      "path": [
        "color",
        "branding-16"
      ]
    },
    "branding-8": {
      "value": "rgba(0, 48, 192, 0.08)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(0, 48, 192, 0.08)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBranding8",
      "path": [
        "color",
        "branding-8"
      ]
    },
    "branding-4": {
      "value": "rgba(0, 48, 192, 0.04)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(0, 48, 192, 0.04)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBranding4",
      "path": [
        "color",
        "branding-4"
      ]
    },
    "primary": {
      "value": "#00abed",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgb(0, 171, 237)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorPrimary",
      "path": [
        "color",
        "primary"
      ]
    },
    "primary-80": {
      "value": "rgba(0, 171, 237, 0.8)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(0, 171, 237, 0.8)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorPrimary80",
      "path": [
        "color",
        "primary-80"
      ]
    },
    "primary-60": {
      "value": "rgba(0, 171, 237, 0.6)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(0, 171, 237, 0.6)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorPrimary60",
      "path": [
        "color",
        "primary-60"
      ]
    },
    "primary-40": {
      "value": "rgba(0, 171, 237, 0.4)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(0, 171, 237, 0.4)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorPrimary40",
      "path": [
        "color",
        "primary-40"
      ]
    },
    "primary-20": {
      "value": "rgba(0, 171, 237, 0.2)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(0, 171, 237, 0.2)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorPrimary20",
      "path": [
        "color",
        "primary-20"
      ]
    },
    "primary-16": {
      "value": "rgba(0, 171, 237, 0.16)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(0, 171, 237, 0.16)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorPrimary16",
      "path": [
        "color",
        "primary-16"
      ]
    },
    "primary-8": {
      "value": "rgba(0, 171, 237, 0.08)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(0, 171, 237, 0.08)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorPrimary8",
      "path": [
        "color",
        "primary-8"
      ]
    },
    "primary-4": {
      "value": "rgba(0, 171, 237, 0.04)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(0, 171, 237, 0.04)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorPrimary4",
      "path": [
        "color",
        "primary-4"
      ]
    },
    "info": {
      "value": "#8296a6",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgb(130, 150, 166)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorInfo",
      "path": [
        "color",
        "info"
      ]
    },
    "info-80": {
      "value": "rgba(130, 150, 166, 0.8)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(130, 150, 166, 0.8)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorInfo80",
      "path": [
        "color",
        "info-80"
      ]
    },
    "info-60": {
      "value": "rgba(130, 150, 166, 0.6)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(130, 150, 166, 0.6)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorInfo60",
      "path": [
        "color",
        "info-60"
      ]
    },
    "info-40": {
      "value": "rgba(130, 150, 166, 0.4)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(130, 150, 166, 0.4)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorInfo40",
      "path": [
        "color",
        "info-40"
      ]
    },
    "info-20": {
      "value": "rgba(130, 150, 166, 0.2)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(130, 150, 166, 0.2)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorInfo20",
      "path": [
        "color",
        "info-20"
      ]
    },
    "info-16": {
      "value": "rgba(130, 150, 166, 0.16)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(130, 150, 166, 0.16)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorInfo16",
      "path": [
        "color",
        "info-16"
      ]
    },
    "info-8": {
      "value": "rgba(130, 150, 166, 0.08)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(130, 150, 166, 0.08)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorInfo8",
      "path": [
        "color",
        "info-8"
      ]
    },
    "info-4": {
      "value": "rgba(130, 150, 166, 0.04)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(130, 150, 166, 0.04)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorInfo4",
      "path": [
        "color",
        "info-4"
      ]
    },
    "success": {
      "value": "#22ac00",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgb(34, 172, 0)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorSuccess",
      "path": [
        "color",
        "success"
      ]
    },
    "success-80": {
      "value": "rgba(34, 172, 0, 0.8)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(34, 172, 0, 0.8)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorSuccess80",
      "path": [
        "color",
        "success-80"
      ]
    },
    "success-60": {
      "value": "rgba(34, 172, 0, 0.6)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(34, 172, 0, 0.6)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorSuccess60",
      "path": [
        "color",
        "success-60"
      ]
    },
    "success-40": {
      "value": "rgba(34, 172, 0, 0.4)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(34, 172, 0, 0.4)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorSuccess40",
      "path": [
        "color",
        "success-40"
      ]
    },
    "success-20": {
      "value": "rgba(34, 172, 0, 0.2)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(34, 172, 0, 0.2)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorSuccess20",
      "path": [
        "color",
        "success-20"
      ]
    },
    "success-16": {
      "value": "rgba(34, 172, 0, 0.16)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(34, 172, 0, 0.16)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorSuccess16",
      "path": [
        "color",
        "success-16"
      ]
    },
    "success-8": {
      "value": "rgba(34, 172, 0, 0.08)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(34, 172, 0, 0.08)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorSuccess8",
      "path": [
        "color",
        "success-8"
      ]
    },
    "success-4": {
      "value": "rgba(34, 172, 0, 0.04)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(34, 172, 0, 0.04)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorSuccess4",
      "path": [
        "color",
        "success-4"
      ]
    },
    "warning": {
      "value": "#f2c100",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgb(242, 193, 0)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorWarning",
      "path": [
        "color",
        "warning"
      ]
    },
    "warning-80": {
      "value": "rgba(242, 193, 0, 0.8)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(242, 193, 0, 0.8)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorWarning80",
      "path": [
        "color",
        "warning-80"
      ]
    },
    "warning-60": {
      "value": "rgba(242, 193, 0, 0.6)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(242, 193, 0, 0.6)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorWarning60",
      "path": [
        "color",
        "warning-60"
      ]
    },
    "warning-40": {
      "value": "rgba(242, 193, 0, 0.4)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(242, 193, 0, 0.4)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorWarning40",
      "path": [
        "color",
        "warning-40"
      ]
    },
    "warning-20": {
      "value": "rgba(242, 193, 0, 0.2)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(242, 193, 0, 0.2)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorWarning20",
      "path": [
        "color",
        "warning-20"
      ]
    },
    "warning-16": {
      "value": "rgba(242, 193, 0, 0.16)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(242, 193, 0, 0.16)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorWarning16",
      "path": [
        "color",
        "warning-16"
      ]
    },
    "warning-8": {
      "value": "rgba(242, 193, 0, 0.08)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(242, 193, 0, 0.08)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorWarning8",
      "path": [
        "color",
        "warning-8"
      ]
    },
    "warning-4": {
      "value": "rgba(242, 193, 0, 0.04)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(242, 193, 0, 0.04)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorWarning4",
      "path": [
        "color",
        "warning-4"
      ]
    },
    "danger": {
      "value": "#ff2f2f",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgb(255, 47, 47)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDanger",
      "path": [
        "color",
        "danger"
      ]
    },
    "danger-80": {
      "value": "rgba(255, 47, 47, 0.8)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 47, 47, 0.8)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDanger80",
      "path": [
        "color",
        "danger-80"
      ]
    },
    "danger-60": {
      "value": "rgba(255, 47, 47, 0.6)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 47, 47, 0.6)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDanger60",
      "path": [
        "color",
        "danger-60"
      ]
    },
    "danger-40": {
      "value": "rgba(255, 47, 47, 0.4)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 47, 47, 0.4)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDanger40",
      "path": [
        "color",
        "danger-40"
      ]
    },
    "danger-20": {
      "value": "rgba(255, 47, 47, 0.2)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 47, 47, 0.2)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDanger20",
      "path": [
        "color",
        "danger-20"
      ]
    },
    "danger-16": {
      "value": "rgba(255, 47, 47, 0.16)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 47, 47, 0.16)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDanger16",
      "path": [
        "color",
        "danger-16"
      ]
    },
    "danger-8": {
      "value": "rgba(255, 47, 47, 0.08)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 47, 47, 0.08)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDanger8",
      "path": [
        "color",
        "danger-8"
      ]
    },
    "danger-4": {
      "value": "rgba(255, 47, 47, 0.04)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 47, 47, 0.04)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDanger4",
      "path": [
        "color",
        "danger-4"
      ]
    },
    "bright": {
      "value": "#ffffff",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgb(255, 255, 255)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBright",
      "path": [
        "color",
        "bright"
      ]
    },
    "bright-80": {
      "value": "rgba(255, 255, 255, 0.8)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 255, 255, 0.8)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBright80",
      "path": [
        "color",
        "bright-80"
      ]
    },
    "bright-60": {
      "value": "rgba(255, 255, 255, 0.6)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 255, 255, 0.6)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBright60",
      "path": [
        "color",
        "bright-60"
      ]
    },
    "bright-40": {
      "value": "rgba(255, 255, 255, 0.4)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 255, 255, 0.4)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBright40",
      "path": [
        "color",
        "bright-40"
      ]
    },
    "bright-20": {
      "value": "rgba(255, 255, 255, 0.2)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 255, 255, 0.2)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBright20",
      "path": [
        "color",
        "bright-20"
      ]
    },
    "bright-16": {
      "value": "rgba(255, 255, 255, 0.16)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 255, 255, 0.16)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBright16",
      "path": [
        "color",
        "bright-16"
      ]
    },
    "bright-8": {
      "value": "rgba(255, 255, 255, 0.08)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 255, 255, 0.08)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBright8",
      "path": [
        "color",
        "bright-8"
      ]
    },
    "bright-4": {
      "value": "rgba(255, 255, 255, 0.04)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 255, 255, 0.04)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBright4",
      "path": [
        "color",
        "bright-4"
      ]
    },
    "misc-green": {
      "value": "#20bf55",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgb(32, 191, 85)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGreen",
      "path": [
        "color",
        "misc-green"
      ]
    },
    "misc-green-80": {
      "value": "rgba(32, 191, 85, 0.8)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(32, 191, 85, 0.8)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGreen80",
      "path": [
        "color",
        "misc-green-80"
      ]
    },
    "misc-green-60": {
      "value": "rgba(32, 191, 85, 0.6)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(32, 191, 85, 0.6)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGreen60",
      "path": [
        "color",
        "misc-green-60"
      ]
    },
    "misc-green-40": {
      "value": "rgba(32, 191, 85, 0.4)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(32, 191, 85, 0.4)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGreen40",
      "path": [
        "color",
        "misc-green-40"
      ]
    },
    "misc-green-20": {
      "value": "rgba(32, 191, 85, 0.2)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(32, 191, 85, 0.2)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGreen20",
      "path": [
        "color",
        "misc-green-20"
      ]
    },
    "misc-green-16": {
      "value": "rgba(32, 191, 85, 0.16)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(32, 191, 85, 0.16)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGreen16",
      "path": [
        "color",
        "misc-green-16"
      ]
    },
    "misc-green-8": {
      "value": "rgba(32, 191, 85, 0.08)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(32, 191, 85, 0.08)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGreen8",
      "path": [
        "color",
        "misc-green-8"
      ]
    },
    "misc-green-4": {
      "value": "rgba(32, 191, 85, 0.04)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(32, 191, 85, 0.04)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGreen4",
      "path": [
        "color",
        "misc-green-4"
      ]
    },
    "misc-blue": {
      "value": "#06aed5",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgb(6, 174, 213)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlue",
      "path": [
        "color",
        "misc-blue"
      ]
    },
    "misc-blue-80": {
      "value": "rgba(6, 174, 213, 0.8)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(6, 174, 213, 0.8)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlue80",
      "path": [
        "color",
        "misc-blue-80"
      ]
    },
    "misc-blue-60": {
      "value": "rgba(6, 174, 213, 0.6)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(6, 174, 213, 0.6)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlue60",
      "path": [
        "color",
        "misc-blue-60"
      ]
    },
    "misc-blue-40": {
      "value": "rgba(6, 174, 213, 0.4)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(6, 174, 213, 0.4)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlue40",
      "path": [
        "color",
        "misc-blue-40"
      ]
    },
    "misc-blue-20": {
      "value": "rgba(6, 174, 213, 0.2)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(6, 174, 213, 0.2)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlue20",
      "path": [
        "color",
        "misc-blue-20"
      ]
    },
    "misc-blue-16": {
      "value": "rgba(6, 174, 213, 0.16)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(6, 174, 213, 0.16)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlue16",
      "path": [
        "color",
        "misc-blue-16"
      ]
    },
    "misc-blue-8": {
      "value": "rgba(6, 174, 213, 0.08)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(6, 174, 213, 0.08)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlue8",
      "path": [
        "color",
        "misc-blue-8"
      ]
    },
    "misc-blue-4": {
      "value": "rgba(6, 174, 213, 0.04)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(6, 174, 213, 0.04)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlue4",
      "path": [
        "color",
        "misc-blue-4"
      ]
    },
    "misc-orange": {
      "value": "#ff8811",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgb(255, 136, 17)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscOrange",
      "path": [
        "color",
        "misc-orange"
      ]
    },
    "misc-orange-80": {
      "value": "rgba(255, 136, 17, 0.8)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 136, 17, 0.8)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscOrange80",
      "path": [
        "color",
        "misc-orange-80"
      ]
    },
    "misc-orange-60": {
      "value": "rgba(255, 136, 17, 0.6)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 136, 17, 0.6)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscOrange60",
      "path": [
        "color",
        "misc-orange-60"
      ]
    },
    "misc-orange-40": {
      "value": "rgba(255, 136, 17, 0.4)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 136, 17, 0.4)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscOrange40",
      "path": [
        "color",
        "misc-orange-40"
      ]
    },
    "misc-orange-20": {
      "value": "rgba(255, 136, 17, 0.2)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 136, 17, 0.2)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscOrange20",
      "path": [
        "color",
        "misc-orange-20"
      ]
    },
    "misc-orange-16": {
      "value": "rgba(255, 136, 17, 0.16)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 136, 17, 0.16)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscOrange16",
      "path": [
        "color",
        "misc-orange-16"
      ]
    },
    "misc-orange-8": {
      "value": "rgba(255, 136, 17, 0.08)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 136, 17, 0.08)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscOrange8",
      "path": [
        "color",
        "misc-orange-8"
      ]
    },
    "misc-orange-4": {
      "value": "rgba(255, 136, 17, 0.04)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 136, 17, 0.04)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscOrange4",
      "path": [
        "color",
        "misc-orange-4"
      ]
    },
    "misc-yellow": {
      "value": "#ffca0a",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgb(255, 202, 10)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscYellow",
      "path": [
        "color",
        "misc-yellow"
      ]
    },
    "misc-yellow-80": {
      "value": "rgba(255, 202, 10, 0.8)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 202, 10, 0.8)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscYellow80",
      "path": [
        "color",
        "misc-yellow-80"
      ]
    },
    "misc-yellow-60": {
      "value": "rgba(255, 202, 10, 0.6)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 202, 10, 0.6)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscYellow60",
      "path": [
        "color",
        "misc-yellow-60"
      ]
    },
    "misc-yellow-40": {
      "value": "rgba(255, 202, 10, 0.4)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 202, 10, 0.4)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscYellow40",
      "path": [
        "color",
        "misc-yellow-40"
      ]
    },
    "misc-yellow-20": {
      "value": "rgba(255, 202, 10, 0.2)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 202, 10, 0.2)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscYellow20",
      "path": [
        "color",
        "misc-yellow-20"
      ]
    },
    "misc-yellow-16": {
      "value": "rgba(255, 202, 10, 0.16)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 202, 10, 0.16)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscYellow16",
      "path": [
        "color",
        "misc-yellow-16"
      ]
    },
    "misc-yellow-8": {
      "value": "rgba(255, 202, 10, 0.08)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 202, 10, 0.08)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscYellow8",
      "path": [
        "color",
        "misc-yellow-8"
      ]
    },
    "misc-yellow-4": {
      "value": "rgba(255, 202, 10, 0.04)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 202, 10, 0.04)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscYellow4",
      "path": [
        "color",
        "misc-yellow-4"
      ]
    },
    "misc-grey": {
      "value": "#62929e",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgb(98, 146, 158)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGrey",
      "path": [
        "color",
        "misc-grey"
      ]
    },
    "misc-grey-80": {
      "value": "rgba(98, 146, 158, 0.8)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(98, 146, 158, 0.8)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGrey80",
      "path": [
        "color",
        "misc-grey-80"
      ]
    },
    "misc-grey-60": {
      "value": "rgba(98, 146, 158, 0.6)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(98, 146, 158, 0.6)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGrey60",
      "path": [
        "color",
        "misc-grey-60"
      ]
    },
    "misc-grey-40": {
      "value": "rgba(98, 146, 158, 0.4)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(98, 146, 158, 0.4)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGrey40",
      "path": [
        "color",
        "misc-grey-40"
      ]
    },
    "misc-grey-20": {
      "value": "rgba(98, 146, 158, 0.2)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(98, 146, 158, 0.2)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGrey20",
      "path": [
        "color",
        "misc-grey-20"
      ]
    },
    "misc-grey-16": {
      "value": "rgba(98, 146, 158, 0.16)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(98, 146, 158, 0.16)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGrey16",
      "path": [
        "color",
        "misc-grey-16"
      ]
    },
    "misc-grey-8": {
      "value": "rgba(98, 146, 158, 0.08)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(98, 146, 158, 0.08)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGrey8",
      "path": [
        "color",
        "misc-grey-8"
      ]
    },
    "misc-grey-4": {
      "value": "rgba(98, 146, 158, 0.04)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(98, 146, 158, 0.04)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscGrey4",
      "path": [
        "color",
        "misc-grey-4"
      ]
    },
    "misc-purple": {
      "value": "#602aba",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgb(96, 42, 186)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscPurple",
      "path": [
        "color",
        "misc-purple"
      ]
    },
    "misc-purple-80": {
      "value": "rgba(96, 42, 186, 0.8)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(96, 42, 186, 0.8)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscPurple80",
      "path": [
        "color",
        "misc-purple-80"
      ]
    },
    "misc-purple-60": {
      "value": "rgba(96, 42, 186, 0.6)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(96, 42, 186, 0.6)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscPurple60",
      "path": [
        "color",
        "misc-purple-60"
      ]
    },
    "misc-purple-40": {
      "value": "rgba(96, 42, 186, 0.4)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(96, 42, 186, 0.4)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscPurple40",
      "path": [
        "color",
        "misc-purple-40"
      ]
    },
    "misc-purple-20": {
      "value": "rgba(96, 42, 186, 0.2)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(96, 42, 186, 0.2)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscPurple20",
      "path": [
        "color",
        "misc-purple-20"
      ]
    },
    "misc-purple-16": {
      "value": "rgba(96, 42, 186, 0.16)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(96, 42, 186, 0.16)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscPurple16",
      "path": [
        "color",
        "misc-purple-16"
      ]
    },
    "misc-purple-8": {
      "value": "rgba(96, 42, 186, 0.08)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(96, 42, 186, 0.08)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscPurple8",
      "path": [
        "color",
        "misc-purple-8"
      ]
    },
    "misc-purple-4": {
      "value": "rgba(96, 42, 186, 0.04)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(96, 42, 186, 0.04)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscPurple4",
      "path": [
        "color",
        "misc-purple-4"
      ]
    },
    "misc-black": {
      "value": "#242325",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgb(36, 35, 37)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlack",
      "path": [
        "color",
        "misc-black"
      ]
    },
    "misc-black-80": {
      "value": "rgba(36, 35, 37, 0.8)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(36, 35, 37, 0.8)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlack80",
      "path": [
        "color",
        "misc-black-80"
      ]
    },
    "misc-black-60": {
      "value": "rgba(36, 35, 37, 0.6)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(36, 35, 37, 0.6)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlack60",
      "path": [
        "color",
        "misc-black-60"
      ]
    },
    "misc-black-40": {
      "value": "rgba(36, 35, 37, 0.4)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(36, 35, 37, 0.4)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlack40",
      "path": [
        "color",
        "misc-black-40"
      ]
    },
    "misc-black-20": {
      "value": "rgba(36, 35, 37, 0.2)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(36, 35, 37, 0.2)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlack20",
      "path": [
        "color",
        "misc-black-20"
      ]
    },
    "misc-black-16": {
      "value": "rgba(36, 35, 37, 0.16)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(36, 35, 37, 0.16)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlack16",
      "path": [
        "color",
        "misc-black-16"
      ]
    },
    "misc-black-8": {
      "value": "rgba(36, 35, 37, 0.08)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(36, 35, 37, 0.08)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlack8",
      "path": [
        "color",
        "misc-black-8"
      ]
    },
    "misc-black-4": {
      "value": "rgba(36, 35, 37, 0.04)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(36, 35, 37, 0.04)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorMiscBlack4",
      "path": [
        "color",
        "misc-black-4"
      ]
    },
    "dark": {
      "value": "#0f2343",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgb(15, 35, 67)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDark",
      "path": [
        "color",
        "dark"
      ]
    },
    "dark-80": {
      "value": "rgba(15, 35, 67, 0.8)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(15, 35, 67, 0.8)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDark80",
      "path": [
        "color",
        "dark-80"
      ]
    },
    "dark-60": {
      "value": "rgba(15, 35, 67, 0.6)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(15, 35, 67, 0.6)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDark60",
      "path": [
        "color",
        "dark-60"
      ]
    },
    "dark-40": {
      "value": "rgba(15, 35, 67, 0.4)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(15, 35, 67, 0.4)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDark40",
      "path": [
        "color",
        "dark-40"
      ]
    },
    "dark-20": {
      "value": "rgba(15, 35, 67, 0.2)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(15, 35, 67, 0.2)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDark20",
      "path": [
        "color",
        "dark-20"
      ]
    },
    "dark-16": {
      "value": "rgba(15, 35, 67, 0.16)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(15, 35, 67, 0.16)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDark16",
      "path": [
        "color",
        "dark-16"
      ]
    },
    "dark-8": {
      "value": "rgba(15, 35, 67, 0.08)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(15, 35, 67, 0.08)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDark8",
      "path": [
        "color",
        "dark-8"
      ]
    },
    "dark-4": {
      "value": "rgba(15, 35, 67, 0.04)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(15, 35, 67, 0.04)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorDark4",
      "path": [
        "color",
        "dark-4"
      ]
    },
    "1-fill-invisible": {
      "value": "rgba(255, 255, 255, 0)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 255, 255, 0.0)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "color1FillInvisible",
      "path": [
        "color",
        "1-fill-invisible"
      ]
    },
    "bright-30": {
      "value": "rgba(255, 255, 255, 0.3)",
      "attributes": {
        "category": "color"
      },
      "filePath": "tokens/color/color.json",
      "isSource": true,
      "original": {
        "value": "rgba(255, 255, 255, 0.3)",
        "attributes": {
          "category": "color"
        }
      },
      "name": "colorBright30",
      "path": [
        "color",
        "bright-30"
      ]
    }
  }
};